/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum BusinessTitle {
  ComplianceProfessional = "ComplianceProfessional",
  ContractsManager = "ContractsManager",
  CorporateGovernanceProfessional = "CorporateGovernanceProfessional",
  DocumentNegotiator = "DocumentNegotiator",
  Investigator = "Investigator",
  IPProfessional = "IPProfessional",
  Lawyer = "Lawyer",
  LegalEngineer = "LegalEngineer",
  LegalOperations = "LegalOperations",
  Paralegal = "Paralegal",
  PrivacyProfessional = "PrivacyProfessional",
}

export const BusinessTitleDisplay: Record<BusinessTitle, string> = {
  [BusinessTitle.ComplianceProfessional]: "Compliance Professional",
  [BusinessTitle.ContractsManager]: "Contracts Manager",
  [BusinessTitle.CorporateGovernanceProfessional]: "Corporate Governance Professional",
  [BusinessTitle.DocumentNegotiator]: "Document Negotiator",
  [BusinessTitle.Investigator]: "Investigator",
  [BusinessTitle.IPProfessional]: "IP Professional",
  [BusinessTitle.Lawyer]: "Lawyer",
  [BusinessTitle.LegalEngineer]: "Legal Engineer",
  [BusinessTitle.LegalOperations]: "Legal Operations",
  [BusinessTitle.Paralegal]: "Paralegal",
  [BusinessTitle.PrivacyProfessional]: "Privacy Professional",
};
